import { Component, OnInit, ViewChild, ViewEncapsulation, Input, OnDestroy, ElementRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { CalendarEvent, CalendarEventAction, CalendarEventTimesChangedEvent, CalendarView } from 'angular-calendar';
import { startOfDay, endOfDay, subDays, addDays, endOfMonth, isSameDay, isSameMonth, addHours } from 'date-fns';
import { FormBuilder, NgForm, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { CreateConsultancyEventComponent } from '../../consultancy-event-create/consultancy-event-create.component';
import { ActivatedRoute } from '@angular/router';
import { GeneralService } from '../../../../../services/general.service';
//import services
import { ConsultancyService } from '../../../../../services/consultancy.service';
import { ConfirmationDialogService } from '../../../../../components/general/modals/confirmation/confirmation.service';

declare var $: any;  
const colors: any = {
  red: {
    primary: '#ad2121',
    secondary: '#FAE3E3',
  },
  blue: {
    primary: '#1e90ff',
    secondary: '#D1E8FF',
  },
  yellow: {
    primary: '#e3bc08',
    secondary: '#FDF1BA',
  },
};

@Component({
  selector: 'app-consultancy-calendar',
  templateUrl: './consultancy-calendar.component.html',
  styleUrls: ['./consultancy-calendar.component.css']
})
export class ConsultancyCalendarComponent implements OnInit {

  lang: any;

  @ViewChild('modalContent') modalContentRef: ElementRef;
  modalData: {event : CalendarEvent};
  modalRef: BsModalRef;
  
  view: CalendarView = CalendarView.Month;
  CalendarView = CalendarView;

  viewDate: Date = new Date();
  activeDayIsOpen: boolean = false;

  actions: CalendarEventAction[] = [
    // {
    //   label: '<i class="fas fa-fw fa-pencil-alt"></i>',
    //   a11yLabel: 'Edit',
    //   onClick: ({ event }: { event: CalendarEvent }): void => {
    //     // this.handleEvent('Edited', event);
    //     alert("Edit")
    //   },
    // },
    {
      label: '<i class="fas fa-fw fa-trash-alt"></i>',
      a11yLabel: 'Delete',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.events = this.events.filter((iEvent) => iEvent !== event);
        this.deleteEvent(event)
      },
    },
  ];
  events: CalendarEvent[] = [];


createForm: FormGroup;
createFormSubmitted: Boolean = false;
createFormErrorMsg: any;
edit_id:string
  
  constructor(
    private formBuilder: FormBuilder,
    private modalService: BsModalService,
    private consultancyService: ConsultancyService,
    private generalService: GeneralService,
    private route: ActivatedRoute,
    private confirmationDialogService: ConfirmationDialogService,
  ) { }

  ngOnInit() {
    this.edit_id = this.route.snapshot.paramMap.get('id');
    this.consultancyService.calendar(this.edit_id)
      .subscribe(
        (res) => {
          this.lang = this.consultancyService.calendarLang(res);

          let details = res.data.calendar;
          let that = this;
          
          if(details){
            details.forEach(element => {
                that.events.push(
                  {
                    start: new Date(element.start.replace( /(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3")),
                    // end: new Date(element.end.replace( /(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3")),
                    title: element.title,
                    meta: {
                      id: element.id,
                      desc : element.des_event
                    },
                    color: colors.red,
                    actions:this.actions,
                  },
                );
            });
          }

        }
      );
      this.FormBuild();
  }


  FormBuild(): void {

    this.createForm = this.formBuilder.group({
      date_event: [''],
      title_event: [''],
      des_event: [''],
      id: '',
      action: 'update',
    });
  }

  deleteEvent(data){
    this.confirmationDialogService.confirm('Delete Confirmation', 'Are you sure want to delete?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.consultancyService.deleteEvent({id:data.meta.id})
            .subscribe(
              (res) => {
                if (res.status)
                this.generalService.notify_msg('success', res.msg);
                else
                this.generalService.notify_msg('success', res.msg);
              });

        });    
  }


  addEvent(): void {
    console.log($("#datatableExport2"))
    let modalRef =this.modalService.show(CreateConsultancyEventComponent, { class: 'modal-lgs', initialState: { 'ID': "",'chapter_id': "", 'langs': this.lang, 'type':this.lang.editChapter, 'mode':'edit' } });
    modalRef.content.passEntry.subscribe((data) => {
      console.log(data);
      let dataParams = {
        "event_date": data.date_event,
        "event_title": data.title_event,
        "event_des": data.des_event,
        "cid": this.edit_id
      }
      this.consultancyService.addEvent(dataParams).subscribe( (res) => {
        if(res.status){
          this.generalService.notify_msg('success', res.msg);
          this.events = [
            ...this.events,
            {
              title: data.title_event,
              start: startOfDay(new Date(data.date_event)),
              // end: endOfDay(new Date()),
              color: colors.red,
              actions:this.actions,
              draggable: true,
              meta:{
                desc:data.des_event,
                // id:data.id,
              },
              resizable: {
                beforeStart: true,
                afterEnd: true
              }
            }
          ];            
        }else{
          this.generalService.notify_msg('error', res.msg);
        }
       
      })
     
    })
  }


  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false;
  }

  setView(view: CalendarView) {
    this.view = view;
  }

  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
        this.activeDayIsOpen = true;
      }
      this.viewDate = date;
    }
  }

  handleEvent(action: string, event: CalendarEvent): void {

    this.modalData = { event: event };
    this.modalRef = this.modalService.show(this.modalContentRef, { class: 'modal-lgs'});

  }

  Clicked() {
    console.log('test');

  }
  

}
